import { render } from "./Grupos.vue?vue&type=template&id=263f0dbc"
import script from "./Grupos.vue?vue&type=script&lang=js"
export * from "./Grupos.vue?vue&type=script&lang=js"

import "./Grupos.vue?vue&type=style&index=0&id=263f0dbc&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__